import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { gsap, ScrollTrigger } from 'gsap/all';
import { fullHeight, useHsHeader } from '../../util/hsHeader';
import { P } from '../../styles/typography';
import { MobileBlockWrapper, AnimatedTextWrapper } from '../../styles/helpers';
import { useDeviceSize } from '../../util/useDeviceSize';

gsap.registerPlugin(ScrollTrigger);

const Container = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  background-color: ${props => props.theme.colors.background};
  ${fullHeight(1.5)};
`;

export default function SplitSticky2({ images, copy }) {
  const rightHalfTriggerRef = useRef();
  const rightHalfPinRef = useRef();
  const leftHaltTriggerRef = useRef();
  const [{ headerHeight }] = useHsHeader();
  const { isWideScreen } = useDeviceSize();

  useEffect(() => {
    if (!isWideScreen) {
      return undefined;
    }

    const rightTl = gsap.timeline().to(rightHalfPinRef.current, {
      duration: 1,
    });

    const rightSt = ScrollTrigger.create({
      trigger: rightHalfTriggerRef.current,
      pin: rightHalfPinRef.current,
      pinSpacing: false,
      animation: rightTl,
      scrub: true,
      start: `top top`,
      end: () =>
        rightHalfTriggerRef.current.getBoundingClientRect().y +
        rightHalfTriggerRef.current.getBoundingClientRect().height -
        rightHalfPinRef.current.getBoundingClientRect().height,
    });

    const leftSt = ScrollTrigger.create({
      trigger: leftHaltTriggerRef.current,
      pin: true,
      pinSpacing: false,
      scrub: true,
      start: `top ${headerHeight}px`,
      end: 'bottom bottom',
    });

    return () => {
      rightTl.kill();
      rightSt.kill();
      leftSt.kill();
    };
  }, [headerHeight, isWideScreen]);

  if (isWideScreen) {
    return (
      <Container
        css={css`
          padding-top: 230px;
        `}
      >
        <div
          css={css`
            padding: 10vh 0 10vh 100px;
            display: flex;
            flex-direction: column;
            width: 50%;
            transform: translateY(-230px);
          `}
          ref={leftHaltTriggerRef}
        >
          <img
            src={images[0].src}
            css={css`
              object-fit: contain;
            `}
            alt=""
          />
        </div>
        <div
          css={css`
            width: 50%;
          `}
          ref={rightHalfTriggerRef}
        >
          <div
            css={css`
              padding: 10vh 220px 10vh 160px;
            `}
            ref={rightHalfPinRef}
          >
            <P>{copy[0].text}</P>
          </div>
        </div>
      </Container>
    );
  }

  return (
    <div>
      <MobileBlockWrapper>
        <img src={images[0].src} alt="" />
      </MobileBlockWrapper>
      <AnimatedTextWrapper>
        <P mobile>{copy[0].text}</P>
      </AnimatedTextWrapper>
    </div>
  );
}

SplitSticky2.propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape({ src: PropTypes.string })),
  copy: PropTypes.arrayOf(PropTypes.shape({ text: PropTypes.node })),
};

SplitSticky2.defaultProps = {
  images: null,
  copy: null,
};
